module.exports = __webpack_public_path__ + "static/dTSBG-fe87230b40baee9c607d5e0daf6b5ac7.png";